import { render, staticRenderFns } from "./HelpfulLinks.vue?vue&type=template&id=15831874&"
import script from "./HelpfulLinks.vue?vue&type=script&lang=js&"
export * from "./HelpfulLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports